/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_OnlineInputs */

const vi_print_admin_online = /** @type {(inputs: Print_Admin_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết nối`)
};

/**

* @param {Print_Admin_OnlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_online = /** @type {((inputs?: Print_Admin_OnlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_OnlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_online(inputs)
});